import { Loader2 } from 'lucide-react';

/**
 * Spinner de carga accesible. Se usa para estados de carga de pantalla
 * completa (verificación de sesión, etc.).
 *
 * El label se anuncia a screen readers vía aria-live y se muestra debajo
 * del spinner cuando está presente.
 */
const LoadingSpinner = ({ label, size = 'md', className = '' }) => {
  const sizeClass = size === 'sm' ? 'h-5 w-5' : size === 'lg' ? 'h-10 w-10' : 'h-7 w-7';

  return (
    <div
      role="status"
      aria-live="polite"
      className={['flex flex-col items-center gap-3', className].join(' ')}
    >
      <Loader2
        className={[sizeClass, 'animate-spin text-brand-700'].join(' ')}
        aria-hidden="true"
      />
      {label ? (
        <span className="text-sm text-slate-500">{label}</span>
      ) : (
        <span className="sr-only">Cargando...</span>
      )}
    </div>
  );
};

export default LoadingSpinner;
